import { __assign } from "tslib";
import { alpha, createBreakpoints } from '@mui/system';
var breakpoints = createBreakpoints({});
export var ButtonTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: {
            textTransform: "none",
            fontWeight: '400',
            boxShadow: "none",
        },
        sizeSmall: function (_a) {
            var _b;
            var theme = _a.theme;
            return (_b = {
                    padding: theme.spacing(0.46875, 1),
                    height: 32,
                    // padding: `0.2344rem 0.5rem`,
                    fontSize: theme.typography.body1.fontSize
                },
                _b[breakpoints.down('sm')] = {
                    fontSize: "0.813rem", //13
                },
                _b);
        },
        sizeMedium: function (_a) {
            var _b;
            var theme = _a.theme;
            return (_b = {
                    padding: theme.spacing(0.96875, 2.5),
                    height: 40,
                    // padding: `0.4844rem 1.25rem`,
                    fontSize: theme.typography.body1.fontSize
                },
                _b[breakpoints.down('sm')] = {
                    fontSize: "0.813rem", //13
                },
                _b);
        },
        sizeLarge: function (_a) {
            var _b;
            var theme = _a.theme;
            return (_b = {
                    padding: theme.spacing(1.75, 4),
                    height: 56,
                    // padding: `0.875rem 2rem`,
                    fontSize: theme.typography.subtitle1.fontSize
                },
                _b[breakpoints.down('sm')] = {
                    fontSize: "0.938rem", //15
                },
                _b);
        },
        outlinedInherit: {
            '&:hover': {
                backgroundColor: "color-mix(in srgb, currentColor 8%, transparent)",
            },
            '&:disabled': {
                borderColor: "color-mix(in srgb, currentColor 16%, transparent)",
                color: "color-mix(in srgb, currentColor 48%, transparent)",
            },
        },
        textInherit: {
            '&:hover': {
                backgroundColor: "color-mix(in srgb, currentColor 8%, transparent)",
            },
            '&:disabled': {
                color: "color-mix(in srgb, currentColor 48%, transparent)",
                // color: alpha(theme.palette.secondary.light, 0.48),
            },
        },
        outlined: function (_a) {
            var ownerState = _a.ownerState;
            return (__assign({}, (ownerState.color &&
                ownerState.color !== 'inherit' && {
                borderColor: theme.palette[ownerState.color][300],
                '&:hover': {
                    borderColor: theme.palette[ownerState.color][300],
                }
            })));
        },
        contained: function (_a) {
            var ownerState = _a.ownerState;
            return (__assign({}, (ownerState.color &&
                ownerState.color !== 'inherit' && {
                '&:hover': {
                    backgroundColor: alpha(theme.palette[ownerState.color].main, 0.92),
                },
            })));
        },
        text: function (_a) {
            var ownerState = _a.ownerState;
            return (__assign({}, (ownerState.color &&
                ownerState.color !== 'inherit' && {
                '&:hover': {
                    backgroundColor: alpha(theme.palette[ownerState.color].main, 0.08),
                },
            })));
        },
    },
    variants: [
        {
            props: { variant: 'outlined', color: 'error' },
            style: {
                borderColor: theme.palette.error[500],
                '&:hover': {
                    borderColor: theme.palette.error[500],
                }
            },
        },
        {
            props: { variant: 'solid' },
            style: {
                textTransform: 'none',
                color: theme.palette.primary.main,
                boxShadow: "none",
                height: "auto",
                padding: "0",
                '&:hover': {
                    textDecoration: "underline",
                    backgroundColor: "transparent",
                },
                '&:focus': {
                    backgroundColor: "transparent",
                },
                '&:active': {
                    backgroundColor: "transparent",
                },
                '&:disabled': {
                    color: alpha(theme.palette.greySecondary.main, 0.48),
                    textDecoration: "underline",
                },
            },
        },
        {
            props: { variant: 'solid', color: 'inherit' },
            style: {
                color: 'inherit',
            },
        },
        {
            props: { variant: 'solid', color: 'primary' },
            style: {
                color: theme.palette.primary.main,
            },
        },
        {
            props: { variant: 'solid', color: 'secondary' },
            style: {
                color: theme.palette.secondary.main,
            },
        },
        {
            props: { variant: 'solid', color: 'success' },
            style: {
                color: theme.palette.success.main,
            },
        },
        {
            props: { variant: 'solid', color: 'error' },
            style: {
                color: theme.palette.error.main,
            },
        },
        {
            props: { variant: 'solid', color: 'info' },
            style: {
                color: theme.palette.info.main,
            },
        },
        {
            props: { variant: 'solid', color: 'warning' },
            style: {
                color: theme.palette.warning.main,
            },
        },
        {
            props: { variant: 'solid', color: 'grey' },
            style: {
                color: theme.palette.grey.main,
            },
        },
        {
            props: { variant: 'solid', color: 'greySecondary' },
            style: {
                color: theme.palette.greySecondary.main,
            },
        },
    ],
}); };
export default ButtonTheme;
//# sourceMappingURL=theme.js.map